<template><p class="availability" :class="{ unavailable: !available, low: low }">{{ label }}</p></template>
<script>
export default {
  props: { product: { type: Object, required: true } },
  computed: {
    quantity() { return Number(this.product.qty) || 0; },
    available() { return this.product.available !== false && this.quantity > 0; },
    low() { return this.available && this.quantity <= 3; },
    label() { return !this.available ? 'Немає в наявності' : this.low ? 'Закінчується' : 'Є в наявності'; },
  },
};
</script>
<style scoped>
.availability { color: #236336; font: 500 12px/18px Inter, sans-serif; margin: 8px 0; }
.availability.low { color: #805100; }
.availability.unavailable { color: #656565; }
</style>
